import { z } from "zod";
import { RequestDtoSchema } from "./RequestDto";

export const GetAllRequestsOutputSchema = z.object({
    items: z.array(RequestDtoSchema).nullish(),
    count: z.number().nullish(),
});

export type GetAllRequestsOutput = z.infer<typeof GetAllRequestsOutputSchema>;